<template>
  <div class="content ct2" @click="closeWarn">
      <h3>文章信息</h3>
      <div class="item">
          <div class="fl ct2-left necessary" @mouseover="isDeleteShow=true" @mouseout="isDeleteShow=false">
            <img :src="articalObj.CoverImageContent" alt="" class="left-img" @click="showCrop" title="点击切换封面图">
            <div class="df left-up" v-show="!articalObj.CoverImageContent" @click="showCrop">
                <div>
                    <div class="add">+</div>
                    <p>上传封面</p>
                </div>
                <div class="ft12">
                    <p>只支持JPG/PNG，大小不超过5M</p>
                    <p>建议尺寸为800X600</p>
                </div>
            </div>
            <!--<div class="delete" v-show="isDeleteShow && articalObj.CoverImageContent" @click="deleteImg"><span class="close">×</span> 删除</div>-->
            <p class="left-nece" v-show="!articalObj.CoverImageContent && isSend">请上传封面图</p>
          </div>
          <div class="ct2-right">
            <div class="input-box necessary">
                <input type="text" placeholder="请输入文章标题" required v-model="articalObj.Name">
                <div class="nece-text" v-show="!articalObj.Name && isSend">
                    <span class="warn-icon">!</span> 必填项
                </div>
            </div>
            <div class="input-box necessary">
                <input type="text" readonly class="arr-down1" :value="directoryName" placeholder="请选择文章类型"/>
                <div class="type-list" v-if="BelongDirectorys.length>0">
                    <ul class="list1"  @mouseout="changeHeight(-1)">
                        <li v-for="(item,index) in (BelongDirectorys[0].Children)" :key="index" @mouseover="changeHeight(1,index)" >
                            <p>{{item.Name}}</p>
                            <ul class="list2">
                                <li v-for="(item1,index) in item.Children" :key="index" :id="item1.Id" @click="chooseDirectory(item.Name,item.Id,item1.Name,item1.Id)">{{item1.Name}}</li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div class="nece-text" v-show="articalObj.ArticleTypeId==0 && isSend">
                    <span class="warn-icon">!</span> 必填项
                </div>
            </div>
            <!--标签列表-->
            <Labels
                :localLabels="localLabels"
                :DailyLabels="DailyLabels"
                :SystemLabels="SystemLabels"
                :HotLabels="HotLabels"
                :obj="articalObj"
            >
            </Labels>
            <div class="input-box" style="margin-top: -2px;">
                <input type="text" placeholder="原文链接" v-model="articalObj.OriginalLink">
            </div>
            <div class="edit-box necessary">
                <!-- 富文本编辑器组件 -->
                <Editor ref="editor" @getContent="getContent" :isSend="isSend"></Editor>
                <div class="nece-text" v-show="!articalObj.Content && isSend">
                    <span class="warn-icon">!</span> 必填项
                </div>
            </div>
            <div class="input-box" @click.stop="openUploader">
                <div class="file-div" v-html="upFileText || '点击上传原文件'" :class="{active: upFileText}"></div>
            </div>
            <div class="up-btn" @click.stop="sendArtical">发布文章</div>
          </div>
      </div>
      <!-- 图片裁剪组件 -->
      <transition name="fade">
        <Cropper ref="cropper" v-if="isCropShow" @changeCrop="getCrop"></Cropper>
      </transition>
      <!-- 提示框 -->
      <Warn ref="warn"></Warn>
      <!-- 确认框 -->
      <Confirm ref="confirm" @handelConfirm="handelConfirm"></Confirm>
      <Uploader ref="uploader"
            :class="{active: isProgress}"
            :isUploaderShow="isUploaderShow" 
            :isDropShow="isDropShow" 
            :isPanelShow="isPanelShow" 
            :isSingleFile="isSingleFile" 
            @getFileName="getFileNameList"
            @closeUploader="closeUploader"
            @removeFile="removeFile"
            @fileSuccess="fileSuccess"
            @fileProgress="fileProgress"
            @fileError="fileError"
        ></Uploader>
  </div> 
</template>
<script>
import Labels from "../common/labels"
import Cropper from "../common/cropper"
import Editor from "../common/quillEditor"
import Warn from "../common/warn"
import Confirm from "../common/confirm"
import Uploader from "../common/uploader"
import {concat} from "../../assets/js/modules/utils"
import {addQuillTitle} from "../../assets/js/modules/quill-title"
import {upLoadArtical,getArticalType,getSystemLabels} from "../../assets/js/modules/shareApi"
import {getArticleDel} from "@/assets/js/modules/articleApi"
export default {
  inject: ['reload'],
  data(){
      return {
          articalObj: {
              Id: null,
              UserId: "",
              Name: "",
              CoverImageContent: "",
              CoverImageExt: "png",
              CoverImgWidth: 0,
              CoverImgHeight: 0,
              ArticleTypeId: 0,
              Labels: [],
              OriginalLink: "",
              Content: "",
              DesignFileObjectKeyCacheKey: "",   //原文件路径
              DesignSourceFileName: "", //原文件名称
          },
          BelongDirectorys:  [],   //分类类型
          directoryName: "",        //文章类型
          isCropShow: false,     //是否显示裁剪框
          isDeleteShow: false,  //是否显示删除
          isSend: false,        //是否点击了发布,
          HotLabels: [],   //热门标签列表
          DailyLabels: [],     //常用标签列表
          localLabels: [],      //本地标签列表
          SystemLabels: [],     //系统标签
          confirmValue: false,
          confirmType: 0,   //确认框操作类型, 1--关闭上传文件, 2--发布文章  
          upFileText: "",       //上传原文件显示文字
          fileNameList: [],         //文件名列表
          isUploaderShow: false,    //是否显示上传框
          isDropShow: false,        //是否显示拖拽框
          isPanelShow: true,        //是否显示标题
          isSingleFile: true,       //是否是单文件上传
          isProgress: false,        //文件是否在上传中
          CommentNumbers: 0,
          LikeNumbers: 0,
      }
  },
  created(){
    this.getQuery();
  },
  mounted(){
    var that = this;
     addQuillTitle();
     this.getArticalType();
  },
  components: {
      Cropper,
      Editor,
      Warn,
      Confirm,
      Uploader,
      Labels
  },
  methods: {
      //获取url参数
      getQuery(){
        if(this.$route.query.uid && this.$route.query.fileId){
            let data = {
                UserId: this.$route.query.uid,
                Id: this.$route.query.fileId
            };
            getArticleDel(data).then(res=>{
                if(res.data.Success){
                    let obj = res.data.Data.Article;    //文章详情
                    for(var prop in this.articalObj){
                        if(obj.hasOwnProperty(prop)){
                            this.articalObj[prop] = obj[prop];
                        }
                    }
                    this.$refs.editor.getContent(this.articalObj.Content);
                    this.directoryName = obj.FirstCategory + ">" + obj.LastCategory;
                    this.upFileText = obj.DesignSourceFileName || "";
                    this.articalObj.DesignSourceFileName = this.articalObj.DesignSourceFileName || "";
                    this.CommentNumbers =  res.data.Data.CommentNumbers;
                    this.LikeNumbers = res.data.Data.LikeNumbers;
                    // console.log(this.articalObj);
                }
            })
        }
      },
      //获取分类
      getArticalType(){
        let userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.articalObj.UserId = userInfo.Id;
        let data = {
            BelongPage: 2,
            UserId: userInfo.Id
        };
        //获取分类类型
        getArticalType(data).then(res=>{
            var result = res.data.Data;
            this.HotLabels = result.HotLabels;
            this.DailyLabels = result.DailyLabels;
            this.BelongDirectorys = result['BelongDirecotrys'];
        })
        this.getLocalLabels();
      },
      //获取本地标签
      getLocalLabels(){
        this.localLabels = (localStorage.getItem("localLabels") && localStorage.getItem("localLabels").split(" ")) || [];
      },
      //显示裁剪框
      showCrop(){
        this.isCropShow = true;
        this.$nextTick(()=>{
            let data = {
                Id: this.articalObj.Id,
                Title: this.articalObj.Name,
                CommentNumbers: this.CommentNumbers,
                LikeNumbers: this.LikeNumbers,
            };
            this.$refs.cropper.getArticleInfo(data);
        })
      },
      //获取裁剪后的数据
      getCrop(data){
        this.isCropShow = data.isShow;
        this.articalObj.CoverImageContent = data.url ? data.url : this.articalObj.CoverImageContent || "";
        this.articalObj.CoverImgWidth = data.width ? data.width : this.articalObj.CoverImgWidth || 0;
        this.articalObj.CoverImgHeight = data.height ? data.height : this.articalObj.CoverImgHeight || 0;
      },
      //删除图片
      deleteImg(){
        this.articalObj.CoverImageContent = "";
      },
      //获取内容 {content: String, isSend: Boolean}
      getContent(data){
        this.articalObj.Content = data.content;
        this.isSend = data.isSend;      //重置,方便子组件监听
      },
      //发布文章
      sendArtical(){
        this.isSend = true;
        //做判断,如果都符合要求,则弹出提示
        if((this.articalObj.Name!="") && (this.articalObj.ArticleTypeId!=0) && this.articalObj.CoverImageContent && (this.articalObj.Content!="")){
            // this.confirmText = "你确定要发布文章吗?";
            // this.confirmType = 2;   //2--发布文章
            // this.isConfirmShow = true;
            let uploader = this.$refs.uploader.uploader;
            this.$refs.warn.message(`请不要关闭当前页面，文章发布中<span class='animate-ellipse-box'><span class='animate-ellipse'>...</span></span>`,false);
            if(uploader && uploader.fileList.length>0 && !uploader.fileList[0].isComplete()){ //有文件
                uploader.fileList[0].resume(); //开始上传
            }else{
                this.uploadArtical();
            }
        }else{
            this.$refs.warn.message("有必填项未填,请填写!",false);
        }
      },
      //关闭提示
      closeWarn(){
        this.$refs.warn.closeWarn();
      },
      //操作确认框 {isShow: Boolean, handel: Boolean}
      handelConfirm(data){
        this.$refs.confirm.closeConfirm();
        this.confirmValue = data.handel;
      },
      //上传文章到后台
      uploadArtical(){
        this.articalObj.ArticleTypeId = parseInt(this.articalObj.ArticleTypeId);
        upLoadArtical(this.articalObj).then(res=>{
            //上传完成后弹出提示并清空值
            if(res.data.Success){
                this.setLocalLabels(this.articalObj.Labels);
                this.$refs.warn.message("文章发布成功!");
                setTimeout(()=>{
                    this.$router.push("/share/artical");
                    this.reload();
                },800)
            }
        })
      },
      //选择分类
      chooseDirectory(name1,id1,name2,id2){
          this.articalObj.ArticleTypeId = id2;
          this.directoryName = name1+">"+name2;
          let data = {MediumCategoryID: id2};
          getSystemLabels(data).then(res=>{
              if(res.data.Success){
                  this.SystemLabels = res.data.Data;
              }
          })
      },
      //获取样式
      getCss(obj, attribute) {
          if (obj.currentStyle) {
              return obj.currentStyle[attribute];
            } else {
                return window.getComputedStyle(obj, null)[attribute];
           }
      },
      //改变list1高度, index--1移入,-1移出, index1--元素下标
      changeHeight(index,index1){
        if(index==-1){
            document.querySelector(".list1").style.height ="auto";
        }else if(index==1){
            var h = this.getCss(document.querySelectorAll(".list2")[index1],"height");
            document.querySelector(".list1").style.height = h;
        }
      },
      //获取文件名列表
      getFileNameList(data){
        this.fileNameList = data;
        this.upFileText = this.fileNameList[0];
        this.articalObj.DesignSourceFileName = this.fileNameList[0];
      },
      //打开上传框并选择文件
      openUploader(){
        this.$refs.uploader.clickme();
        this.isUploaderShow = true;
        this.isPanelShow = true;
      },
      //关闭上传框
      closeUploader(){
        if(this.$refs.uploader.uploader.fileList.length==0){
            this.isPanelShow = this.isUploaderShow = false;
            return;
        }
        this.confirmType = 1; //1--关闭上传框
        this.$refs.confirm.openConfirm("关闭将会中断正在上传的文件以及取消上传将要上传的文件<br/>你确定要关闭吗?");
      },
      //文件上传成功
      fileSuccess(res){
        //console.log(res);
        this.articalObj.DesignFileObjectKeyCacheKey = res[0].Data.IsUpLoaded ? res[0].Data.FileObjectCahcheKey : res[0].Data;
        this.uploadArtical();
      },
      fileProgress(file){
        this.isProgress = true;
      },
      fileError(){
        this.$refs.warn.message("文件上传失败,请重试!");
      },
      //移除一个文件
      removeFile(file){
        this.$refs.uploader.uploader.removeFile(file);
        if(this.$refs.uploader.uploader.fileList.length==0){
            this.upFileText = "";
        }
      },
      //设置本地标签
      setLocalLabels(list){
        let arr = this.localLabels;
        arr = concat(arr,list);
        arr.splice(10,(arr.length-10 > 0 ? arr.length-10 : 0));
        this.localLabels = arr;
        localStorage.setItem('localLabels',arr.join(" "));
      }
  },
  watch: {
      confirmValue: {
          handler: function(){
              if(this.confirmValue ){
                let uploader = this.$refs.uploader.uploader;
                switch(this.confirmType){
                    case 1:     //关闭上传
                        uploader.cancel();
                        this.isPanelShow = this.isUploaderShow = false;
                        if(this.isProgress){
                            this.$refs.warn.message("取消文件上传,请重新发布文章!");
                        }
                        break;
                    case 2:  //发布文章并开始上传文件
                        // this.warnText = `请不要关闭当前页面，文章发布中<span class='animate-ellipse-box'><span class='animate-ellipse'>...</span></span>`;
                        // this.isAutoClose = false;
                        // this.isWarnShow = true;
                        // if(uploader && uploader.fileList.length>0){ //有文件
                        //     uploader.fileList[0].resume(); //开始上传
                        // }else{
                        //     this.uploadArtical();
                        // }
                        break;
                }
                this.confirmValue = false;
              }
          },
          immediate: true
      }
  },
}
</script>
<style scoped>
.ct2>h3, .ct2 .item{
    padding-left: 30px;
}
.ct2>h3{
    height: 60px;
    line-height: 60px;
    color: #666;
    border-bottom: 1px solid #e7e7e7;
}
.item{
    padding: 30px 0;
    font-size: 14px;
    color: #999;
}
.ct2-left{
    background-color: #f2f3f4;
    position: relative;
}
.left-img{
    display: block;
    width: 240px;
    height: 180px;
    position: relative;
    cursor: pointer;
}
.left-up{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 14px;
    color: #999;
    cursor: pointer;
}
.ft12{
    font-size: 12px;
    margin-top: 20px;
}
.add{
    width: 40px;
    height: 40px;
    line-height: 36px;
    border-radius: 50%;
    background-color: #ff9933;
    color: #fff;
    font-size: 36px;
    display: inline-block;
    margin-bottom: 5px;
}
.delete{
    position: absolute;
    right: 10px;
    top: 10px;
    padding: 0 10px;
    background-color: rgba(0,0,0,.8);
    line-height: 20px;
    height: 20px;
    border-radius: 10px;
    color: #fff;
    cursor: pointer;
}
.close{
    font-size: 20px;
    display: inline-block;
    vertical-align: middle;
    margin-top: -4px;
}
.left-nece{
    position: absolute;
    bottom: -30px;
    line-height: 30px;
    color: #ff0000;
}
.ct2-right{
    margin: 0 97px 0 260px;
}
.input-box{
    height: 40px;
    line-height: 40px;
    margin-bottom: 15px;
    box-sizing: border-box;
    position: relative;
}
.necessary{
    position: relative;
}
.necessary::before{
    position: absolute;
    left: -14px;
    content: "●";
    width: 5px;
    height: 5px;
    color: #ff0000;
}
.input-box input, .input-box select{
    width: 100%;
    height: 100%;
    border: 1px solid #e7e7e7;
    border-radius: 5px;
    background-color: #f8f8f8;
    box-sizing: border-box;
    padding: 0 25px 0 15px;
}
.input-box select{
    -webkit-appearance: none;
    color: #999;
}
.input-box .file{
    opacity: 0;
    display: none;
}
.input-box .file-div{
    border: 1px solid #e7e7e7;
    border-radius: 5px;
    background-color: #f8f8f8;
    box-sizing: border-box;
    padding: 0 25px 0 15px;
    margin-top: 20px;
}
.input-box .file-div.active{
    color: #666;
}
.nece-text{
    position: absolute;
    right: -70px;
    top: 0;
    height: 100%;
    font-size: 12px;
    color: #ff0000;
}
.warn-icon{
    padding: 0 6.25px;
    border-radius: 50%;
    background-color: #ff0000;
    color: #fff;
}
.type-list{
    position: absolute;
    top: 40px;
    left: 0;
    z-index: 9;
    display: none;
    line-height: 32px;
}
.input-box:hover .type-list{
    display: block;
}
.list1{
    width: 100px;
    box-sizing: border-box;
    border: 1px solid #e7e7e7;
    background-color: #fff;
    border-radius: 5px;
}
.list1 p{
    text-align: center;
    cursor: default;
}
.list1>li:hover, .list2>li:hover{
    background-color: #6699ff;
    color: #fff;
}
.list2{
    position: absolute;
    left: 100%;
    top: -1px;
    width: 300px;
    box-sizing: border-box;
    display: none;
    border: 1px solid #e7e7e7;
    border-radius: 5px;
    background-color: #fff;
}
.list1>li:hover .list2{
    display: block;
    color: #999;
}
.list2 li{
    cursor: pointer;
    padding-left: 20px;
}
.arr-down1{
    background: url(../../assets/img/arr_down_icon.png) no-repeat right 12px center;
}
.label-container{
    -ms-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
}
.labelling{
    position: absolute;
    right: 20px;
    top: 0;
    height: 100%;
}
.label-box{
    margin-bottom: 15px;
}
.label{
    line-height: 20px;
    height: 20px;
    padding: 0 12px;
    background-color: #e9e9e9;
    border-radius: 4px;
    margin: 0 10px 10px 0;
    cursor: pointer;
}
.label.active{
    background-color: #6699ff;
    color: #fff;
}
.label-right{
    margin-left: 76px;
}
.label .close{
    display: inline-block;
    font-size: 20px;
    vertical-align: middle;
    margin-top: -5px;
}
.more-label, .less-label{
    cursor: pointer;
}
textarea{
    width: 100%;
    height: 300px;
    box-sizing: border-box;
    border: 1px solid #e7e7e7;
}
.up-btn{
    width: 390px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #ff9933;
    border-radius: 20px;
    text-align: center;
    color: #999;
    margin: 45px auto;
    cursor: pointer;
    transition: all 0.3s;
}
.up-btn:hover{
    background-color: #ff9933;
    color: #fff;
}
.slide-enter-active, .slide-leave-active{
    transition: all 0.5s ease-out;
}
.slide-enter,.slide-leave-active{
    transform: translateY(10px);
}
.fade-enter-active,
.fade-leave-active {
    transition: all .3s ease-in-out;
}
.fade-enter,.fade-leave-active{
    opacity: 0;
}
.ct2>>>.uploade-box.active .remove-icon{
    display: none;
}

.edit-box>>>.ql-editor .ql-video{
    width: 100%;
    height: 294px;
}
</style>



// WEBPACK FOOTER //
// src/components/share/shareartical.vue